import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, vShow as _vShow, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "background w-screen flex items-center justify-center flex-col h-screen fixed top-0 left-0 z-50"
}
const _hoisted_2 = ["initial", "enter"]
const _hoisted_3 = { class: "md:w-1/2" }
const _hoisted_4 = { class: "message-box bg-white rounded-lg px-8 py-8 flex flex-col lg:flex-row items-center border-b-4 border-yellow-500" }
const _hoisted_5 = { class: "w-[25%] h-48 flex justify-center items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "w-[80%]" }
const _hoisted_8 = { class: "flex justify-center flex-row space-x-2" }
const _hoisted_9 = { class: "text-xl md:text-2xl text-center" }
const _hoisted_10 = { class: "flex flex-row" }
const _hoisted_11 = { class: "mt-8 flex flex-row w-full items-center justify-center gap-8" }
const _hoisted_12 = { class: "w-full flex justify-center items-center mt-8 space-x-4" }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageVoice = _resolveComponent("MessageVoice")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_RecordStream = _resolveComponent("RecordStream")!
  const _component_FeedbackObjective = _resolveComponent("FeedbackObjective")!
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.feedbackType == 'material')
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "box-complete-items-msg bg-bl flex flex-col md:flex-row space-y-4 md:space-x-8 justify-center items-center md:items-start pb-8",
            initial: _ctx.initialMotion,
            enter: _ctx.enterMotion
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: _ctx.homeroAvatar,
                    class: "avatar-homero",
                    alt: "avatarHomero"
                  }, null, 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.$t("labels.generic", {
                    pt: "O conteúdo apresentado foi satisfatório?",
                    en: "Was the content presented satisfactory?",
                  })), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_MessageVoice, {
                      msg: "O conteúdo apresentado foi satisfatório?",
                      showPlayButton: false,
                      showRepeatButton: false,
                      showSpeedButton: false,
                      onOnEndMessage: _ctx.permissToListen
                    }, null, 8, ["onOnEndMessage"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Button, {
                      class: _normalizeClass(`btn-outline`),
                      disabled: _ctx.talking,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sendLike(true)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(`flex gap-2 items-center ${_ctx.active.like}`)
                        }, [
                          _createVNode(_component_v_icon, {
                            name: "md-thumbup-outlined",
                            class: "text-green-500",
                            scale: "1.5"
                          })
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_Button, {
                      class: _normalizeClass(`btn-outline`),
                      disabled: _ctx.talking,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sendLike(false)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(`flex gap-2 items-center ${_ctx.active.dislike}`)
                        }, [
                          _createVNode(_component_v_icon, {
                            name: "md-thumbdown-outlined",
                            class: "text-h-error-400",
                            scale: "1.5"
                          })
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_v_icon, {
                      name: "md-spatialaudiooff",
                      class: "text-primary-400"
                    }),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
                    pt: "Você também pode responder por voz. Ex: 'Sim', 'Gostei' ou 'Não'",
                    en: "You can also reply by voice. Ex: 'Yes', 'Like' or 'No'",
                  })), 1)
                  ])
                ])
              ])
            ])
          ], 8, _hoisted_2)), [
            [_directive_motion]
          ]),
          _withDirectives(_createVNode(_component_RecordStream, {
            ref: "recordStream",
            encodeType: "liked"
          }, null, 512), [
            [_vShow, _ctx.recording]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.feedbackType == 'objective')
      ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
          _createVNode(_component_FeedbackObjective, {
            itemId: _ctx.itemId,
            idCourse: _ctx.idCourse,
            idUser: _ctx.idUser,
            onOnSendFeedback: _ctx.sendFeedback
          }, null, 8, ["itemId", "idCourse", "idUser", "onOnSendFeedback"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}